module.exports = __webpack_public_path__ + "img/Location.2c211efa.png";